import { useNavigate } from "react-router-dom";
import ReactHelmet from "../../Components/ReactHelmet";
import SidePanel from "../../Components/SidePanel";
import "./Book.css";
import { useEffect, useState } from "react";
import Styles from "./Book.module.css";
import TopBar from "../../Components/TopBar";
import RightSidePanel from "../../Components/RightSidePanel";
import MobileBook from "./MobileBook";
import { FaReadme } from "react-icons/fa6";
import { BookJson } from "./BookModel";
import Lock from "../../Components/Lock";
import { useSelector } from "react-redux";
import { get_contact_batch } from "../../Action/ContactBatchAction";
import { useDispatch } from "react-redux";
import { Book_Details } from "../../Action/BookDemoAction";
import Loading from "../../Components/Loading";
export default function Book() {
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);
  const { bookDet, loading, error } = useSelector(
    (s) => s.Book_Details_Reducer
  );

  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const Mobile_Screen = window.innerWidth;
  useEffect(() => {
    dispatch(Book_Details());
  }, [dispatch]);
  return Mobile_Screen <= 880 ? (
    <MobileBook />
  ) : (
    <>
      <div className={Styles.Dashboard}>
        <ReactHelmet title={"Testifyi Books"} description={"Student Books"} />
        {/* SidePanel */}
        {Mobile_Screen >= 780 ? (
          <SidePanel
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            SetSideBarOpen2={setOpenMenuBar2}
            SidebarOpen2={OpenMenuBar2}
            Page="Dashboard"
          />
        ) : (
          ""
        )}

        {loading ? <Loading /> : ""}
        {/* 
        {EnrollActive ? (
          <Enroll
            setEnrollActive={setEnrollActive}
            Package_Id={EnrollActive}
            courseId={CourseId}
          />
        ) : (
          ""
        )} */}

        {Mobile_Screen <= 480 && SidebarOpen ? (
          <SidePanel
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            Page="Books"
          />
        ) : (
          ""
        )}
        <section className={Styles.MiddleSection}>
          <div style={{ marginTop: "20px" }}>
            <TopBar
              SetSideBarOpen={SetSideBarOpen}
              SidebarOpen={SidebarOpen}
              SetSideBarOpen2={setOpenMenuBar2}
              SidebarOpen2={OpenMenuBar2}
              PageName={"Testifyi Books"}
            />
          </div>
          <div className="Books_Reader">
            {bookDet ? (
              <div class="books-container">
                {BookJson?.map((ev, i) => (
                  <div class="book-card" data-book={i + 1}>
                    {/* <div class="book-header">
                      <h3 class="book-title">
                        {ev?.BookName?.replaceAll("-", " ")}
                      </h3>
                      <span class="book-status">Available</span>
                    </div> */}

                    <div class="book-cover-section">
                      <img
                        src={
                          process.env.REACT_APP_DOC + "/Books/" + ev?.Book_Cover
                        }
                        alt="The Adventure Begins"
                        class="book-cover-img"
                      />
                      <span className="e-book">E-BOOK</span>
                    </div>
                    <h3 class="book-title">
                      {ev?.BookName?.replaceAll("-", " ")}
                    </h3>

                    <div class="book-meta">
                      <div class="meta-item">
                        <span class="meta-icon">📄</span>
                        <span class="meta-text">{ev?.Pages} pages</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-icon">⭐</span>
                        <span class="meta-text">{ev?.Rating} rating</span>
                      </div>
                    </div>

                    <button
                      class="action-btn primary"
                      onClick={() => Navigate(`/student/book/${ev?.BookName}`)}
                    >
                      <span>Read Book</span>
                      <span class="btn-icon" style={{ marginTop: "8px" }}>
                        <FaReadme />
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <Lock />
              </div>
            )}
          </div>
        </section>

        {/* <RightSidePanel
          SetSideBarOpen={setOpenMenuBar2}
          SidebarOpen={OpenMenuBar2}
        />
        <div
          onClick={() => {
            SetSideBarOpen(false);
            setOpenMenuBar2(false);
          }}
          className={SidebarOpen || OpenMenuBar2 ? "overlay active" : "overlay"}
          id="overlay"
        ></div> */}
      </div>
    </>
  );
}
